<template>
  <a-row>
    <a-col v-if="devType === 'mobile' ">
      <a-menu
        v-model="current"
        mode="horizontal"
        @click="handleMenu"
      >
        <a-menu-item key="qrcode" style="padding: 0px 8px 0px 8px;">
          <a style="color: #1890ff;">推广页面二维码</a>
        </a-menu-item>
        <a-menu-item key="preview" style="padding: 0px 8px 0px 8px;">
          <a style="color: #1890ff;">效果预览</a>
        </a-menu-item>
      </a-menu>
    </a-col>
    <a-col v-if="menu_tag === 'qrcode' || devType === 'pc'" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <a-row>
          <a-col :span="24" class="t-center">
            <p v-if="showhelp">请设置广告模板</p>
            <img v-else="" :src="qrurl"/>
          </a-col>
        </a-row>  
        <a-row>
          <a-col :span="24" class="t-center">
            <a-button type="primary" @click="addAdsQrcode">保存</a-button>
          </a-col>
          <!-- a-col :span="12" class="t-center">
            <a-button type="primary"> <a :href="landing_url" target="black"> 预览</a> </a-button>
          </a-col -->
        </a-row>
    </a-col>
    <a-col v-if="menu_tag === 'preview' || devType === 'pc'" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <a-row v-if="landing_url != ''">
          <a-col :span="24"
            class="mobile-view"
            style="height: 600px;"
            >
            <a-row style="height: 18px;">
            </a-row>
            <a-row class="preview-frame" style="text-align: center">
              <iframe :src="landing_url" height="560px" width="281px" scrolling="no" style="border: 0px;border-radius:25px;"/>
            </a-row>
          </a-col>
        </a-row >
    </a-col>
  </a-row>
</template>

<script>

import QRCode from 'qrcode'
import {BACKEND_API_PREFIX, SHARE_LINK_HOST} from '@/util/config'

export default {
  name: 'advertqrcode',
  data() {
    return {
      devType: 'pc',
      current: ['qrcode'],
      menu_tag: "qrcode",
      tab: 'advert',
      qrurl: "",
      backen_api_prefix: BACKEND_API_PREFIX,
      tp_news_id: this.news_id,
      landing_url: ""
    }
  },
  props: {
    news_id: {
      type: String,
      default: function() {
        return ""
      }
    },
    news_url: {
      type: String,
      default: function() {
        return ""
      }
    },
    ads_id: {
      type: String,
      default: function() {
        return ""
      }
    }
  },
  watch: {
  },
  components: {
  },
  methods: {
    handleMenu (value) {
      this.menu_tag= value.key;
    },
    addAdsQrcode: function() {
      let postdata = {
        task: "GEN_INSTANCE",
        news_id: this.news_id,
        ads_id: this.ads_id,
        "api-path": "ads"
      }
      let that = this;
      that.post(postdata["api-path"], postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.$message.success("保存成功");
            that.$emit('change');
          } else {
            that.$message.error("保存失败");
          }
        }).catch(function (e) {
          this.$message.error("保存失败");
      });
    }
  },
  created() {
    let deviceWidth = document.body.clientWidth
    if (deviceWidth <= 500) {
      this.devType = 'mobile';
    }
    let ht = this.news_url.split("https");
    if (!this.ads_id || this.ads_id == "") {
      this.showhelp = true;
    } else {
      this.showhelp = false;
      let that = this;
      if (ht.length == 2) {
        that.landing_url = "https://" + SHARE_LINK_HOST + "/ads/" + that.ads_id + "/" + that.news_id + ".html?prefix=" + that.backend_api_prefix;
      } else {
        that.landing_url = "http://" + SHARE_LINK_HOST + "/ads/" + that.ads_id + "/" + that.news_id + ".html?prefix=" + that.backend_api_prefix;
      }
      QRCode.toDataURL(that.landing_url, function (error, url) {
        if (error)
          console.error(error)
        that.qrurl = url;
      })
    }
  }
}
</script>

<style scoped>
  .t-center {
    text-align: center;
    margin-top: 30%;
  }
  .mobile-view {
    background-image: url('../../assets/img/mobile-panel.png');
    background-size: 320px 600px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
  }
  .preview-frame {
    width: 281px;
    height: 560px;
    margin: auto;
    border: 0px;
    border-radius:25px;
  }
</style>
